import { REFRESH_POPUP_VIEW } from 'store/actions/listActions';

export default (previousState = 0, { type }) => {

    switch (type) {
        case REFRESH_POPUP_VIEW:
            return previousState + 1;

        default:
            return previousState;
    }

}